"use client";

/**
 * Fixed, centered puma watermark — stays put while the page scrolls.
 * Sits under app chrome (z-0); content is z-[1] in providers.
 * Theme bloom via `.brand-watermark-mark` (soft red in light; none in dark).
 */

export default function BrandWatermark() {
  return (
    <div
      aria-hidden
      data-print-hide
      className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center overflow-hidden"
    >
      <img
        src="/brand/puma-filmstrip-transparent.png"
        alt=""
        draggable={false}
        className="brand-watermark-mark w-[min(72vw,520px)] max-w-none select-none opacity-[0.065] dark:opacity-[0.1]"
      />
    </div>
  );
}
